@if (label) {
  <p-floatLabel>
    <ng-template [ngTemplateOutlet]="dropdown"></ng-template>
    <label [for]="inputId">{{ label }}</label>
  </p-floatLabel>
} @else {
  <ng-template [ngTemplateOutlet]="dropdown"></ng-template>
}

<ng-template #dropdown>
  <p-dropdown
    #select
    [options]="_options | orderBy: sort | orderBy: (isFilterSelectedItem ? '-isSelected:boolean' : null)"
    [(ngModel)]="_selectedItem"
    [editable]="editable"
    (onChange)="onChangeValue($event)"
    (onShow)="onShowPanel()"
    (onHide)="onHidePanel()"
    (onFilter)="onFilter.emit($event)"
    [placeholder]="placeholder"
    [inputId]="inputId"
    [filter]="filter"
    [filterBy]="filterBy"
    [dataKey]="optionValue"
    [disabled]="disabled"
    [styleClass]="'w-full ' + styleClass"
    [class]="(isError ? 'ng-invalid ng-dirty ' : '') + class"
    [emptyFilterMessage]="emptyFilterMessage"
    [emptyMessage]="emptyMessage"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    [showClear]="showClear"
    [panelStyleClass]="mergedPanelStyleClass"
    [appendTo]="appendTo ?? 'body'"
    [virtualScroll]="virtualScroll"
    [virtualScrollItemSize]="virtualScrollItemSize"
    [virtualScrollOptions]="virtualScrollOptions"
    [panelStyle]="panelStyle"
    [scrollHeight]="scrollHeight"
    [checkmark]="checkmark"
    [group]="group"
    [loading]="loading">
    @if (groupTemplate) {
      <ng-template
        let-group
        pTemplate="group">
        <ng-template
          [ngTemplateOutlet]="groupTemplate"
          [ngTemplateOutletContext]="{ group: group }"></ng-template>
      </ng-template>
    }

    <ng-template pTemplate="selectedItem">
      @if (selectedItemTemplate || isTemplateCombined) {
        <ng-template
          [ngTemplateOutlet]="isTemplateCombined ? selectedItemTemplate || itemTemplate : selectedItemTemplate"
          [ngTemplateOutletContext]="{
            item: _selectedItem | findBySelectedItem: _options : optionValue : group
          }"></ng-template>
      } @else if (_selectedItem) {
        <div class="color-black">
          <span
            [innerHTML]="
              highlightMatchText(
                _selectedItem | findBySelectedItem: _options : optionValue : group | nestedProperty: optionLabel
              ) | safeHtml
            "></span>
        </div>
      }
    </ng-template>

    <ng-template
      let-item
      pTemplate="item">
      @if (itemTemplate || isTemplateCombined) {
        <div [ngClass]="itemStyleClass">
          <ng-template
            [ngTemplateOutlet]="isTemplateCombined ? selectedItemTemplate || itemTemplate : itemTemplate"
            [ngTemplateOutletContext]="{ item: item }"></ng-template>
        </div>
      } @else {
        <div>
          <div [ngClass]="itemStyleClass">
            <span [innerHTML]="highlightMatchText(item | nestedProperty: optionLabel) | safeHtml"></span>
          </div>

          @if (itemDescriptionField) {
            <div class="frm-color-green">
              {{ item | nestedProperty: itemDescriptionField }}
            </div>
          }

          @if (itemSubDescriptionField) {
            <div class="frm-color-blue-light text-xs">
              {{ item | nestedProperty: itemSubDescriptionField }}
            </div>
          }
        </div>
      }
    </ng-template>

    @if (footerTemplate) {
      <ng-template pTemplate="footer">
        <ng-template [ngTemplateOutlet]="footerTemplate"></ng-template>
      </ng-template>
    }

    @if (emptyTemplate) {
      <ng-template pTemplate="empty">
        <ng-template [ngTemplateOutlet]="emptyTemplate"></ng-template>
      </ng-template>
    }
  </p-dropdown>

  @if (errorMessage) {
    <small class="error p-error">
      {{ errorMessage }}
    </small>
  }
</ng-template>
